<template>
  <div class="title-banner">
    <div class="title-banner__lead">
      <svg-back v-show="showBack" class="title-banner__icon svg-fill" @click="onClose" />
      <svg-close v-show="showClose" class="title-banner__icon svg-fill" @click="onClose" />
    </div>
    <div class="title-banner__middle">
      <label>{{ title }}</label>
    </div>
    <div class="title-banner__end">
      <button v-if="rightButtonTitle" class="title-banner__action" @click="onRightAction">
        {{ rightButtonTitle }}
      </button>
    </div>
  </div>
</template>

<script>
import SvgBack from '../../assets/svg/back.svg?inline'
import SvgClose from '../../assets/svg/close.svg?inline'

export default {
  components: {
    'svg-back': SvgBack,
    'svg-close': SvgClose,
  },
  methods: {
    /**
     * dismiss the screen
     */
    onClose() {
      this.$emit('close')
    },
    /**
     * right button action
     */
    onRightAction() {
      this.$emit('rightAction')
    },
  },
  name: 'TitleBanner',
  props: {
    /**
     * right button title
     */
    rightButtonTitle: {
      default: '',
      type: String,
    },
    /**
     * display back arrow
     */
    showBack: {
      default: false,
      type: Boolean,
    },
    showClose: {
      default: false,
      type: Boolean,
    },
    /**
     * display title
     */
    title: {
      default: '',
      type: String,
    },
  },
}
</script>

<style scoped>
.title-banner {
  @apply flex items-center;
  @apply px-2 shadow;
  @apply bg-white;
  height: 56px;

  & .title-banner__lead {
    @apply flex;
    min-width: 60px;
  }

  & .title-banner__end {
    @apply flex justify-end;
    min-width: 60px;
  }

  & .title-banner__icon {
    @apply w-b-sm h-b-sm;
    @apply cursor-pointer;
    @apply text-grey-900;
  }

  & .title-banner__middle {
    @apply flex items-center;
    @apply flex-1 mx-2;
  }

  & label {
    @apply flex-1 text-17/4 text-center;
  }

  & .title-banner__action {
    @apply mr-2 text-red-500;
    @apply outline-none border-none;
  }
}
</style>
